import React from 'react';
import HeroSection from '@/components/sections/prototype/HeroSection';
import ProblemSection from '@/components/sections/prototype/ProblemSection';
import PhilosophySection from '@/components/sections/prototype/PhilosophySection';
import PricingSection from '@/components/sections/prototype/PricingSection';
import ComparisonSection from '@/components/sections/prototype/ComparisonSection';
import ResultsSection from '@/components/sections/prototype/ResultsSection';
import DemoSection from '@/components/sections/prototype/DemoSection';
import ContactForm from '@/components/sections/prototype/ContactForm';
import CTASection from '@/components/sections/prototype/CTASection';
import SEO from '@/components/SEO';
import FAQ from '@/components/ui/FAQ';
import BookingModule from '@/components/sections/BookingModule';

const PrototypeDevelopment = () => {
  const faqItems = [
    {
      question: "Quelle différence entre un prototype et un MVP ?",
      answer: "Le prototype sert à tester une idée et un usage. Le MVP teste le marché et le modèle économique. Le premier valide l'intérêt, le second la viabilité."
    },
    {
      question: "Puis-je lever des fonds avec un prototype ?",
      answer: "Oui — c'est souvent le meilleur moyen de convaincre sans développement coûteux. Vous montrez un produit concret, mesurable et attractif."
    },
    {
      question: "Travaillez-vous en code ou en no-code ?",
      answer: "Les deux. Nous utilisons Figma, FlutterFlow, Bubble ou React selon les besoins. L'objectif : aller vite sans compromettre la suite."
    },
    {
      question: "Combien de temps faut-il ?",
      answer: "Entre 2 et 6 semaines, selon la formule et le niveau d'interactivité."
    },
    {
      question: "Que se passe-t-il après la livraison ?",
      answer: "Vous êtes libre : continuer seul, lancer la V1 avec nous, ou présenter votre prototype à des investisseurs. Le livrable est 100 % réutilisable et documenté."
    }
  ];

  return (
    <>
      <SEO 
        title="Prototype de Produit | Testez votre idée avant d'investir"
        description="Transformez votre idée en prototype testable et convaincant en quelques semaines. Prototypes interactifs, tests utilisateurs, dashboards de suivi. Validez votre concept avant de développer."
        keywords="prototype, MVP, validation d'idée, test utilisateur, produit minimum viable, wireframe, design prototype, no-code, low-code, validation startup"
        type="service"
        url="https://innov.orcsys.fr/prototype"
        image="https://innov.orcsys.fr/images/prototype-development-preview.jpg"
      />
      <div className="min-h-screen bg-white">
        <HeroSection />
        <ProblemSection />
        <PhilosophySection />
        <PricingSection />
        <ComparisonSection />
        <ResultsSection />
        <DemoSection />
        <ContactForm />
        <CTASection />
        <BookingModule />
        <FAQ 
          title="💬 Questions Fréquentes"
          subtitle="Tout ce que vous devez savoir sur nos prototypes"
          items={faqItems}
          className="bg-slate-50"
        />
      </div>
    </>
  );
};

export default PrototypeDevelopment;

